if (!customElements.get('atomic-comparison')) {
  customElements.define('atomic-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-competitor]');
        if (!button || !this.contains(button)) return;
        this.querySelector('.flow-comparison-glass').dataset.competitor = button.dataset.competitor;
        this.querySelectorAll('button[data-competitor]').forEach((option) => {
          option.setAttribute('aria-pressed', String(option === button));
        });
      });
    }
  });
}
